import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretSmallDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.29289 12.2929C8.68342 11.9024 9.31658 11.9024 9.70711 12.2929L16 18.5858L22.2929 12.2929C22.6834 11.9024 23.3166 11.9024 23.7071 12.2929C24.0976 12.6834 24.0976 13.3166 23.7071 13.7071L16.7071 20.7071C16.3166 21.0976 15.6834 21.0976 15.2929 20.7071L8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929Z",
		fill: "currentColor"
	})
});
export default SvgCaretSmallDown;
